// extracted by mini-css-extract-plugin
export default {"font-renta":"DeposList_font-renta__J1ZHR","deposList":"DeposList_deposList__fGdhm","toolbar":"DeposList_toolbar__KShMA","depoGrid":"DeposList_depoGrid__6VKhw"};